import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'

const resource = 'audiences'
const verb = 'post'

export default class OspreyAudienceEstimatedConsumers extends BaseAction {
    constructor(dataKey, onError) {
        const id = 'f6ffe83b-d73d-494e-893c-d821dd52a526'
        const path = `/${resource}`
        super(resource, verb, path, id, dataKey)
        this.noCache = true

        this.onError = onError
    }

    getEstimateConsumers(params, contextOrn) {
        this.path = `/${resource}/estimates`
        this.params = Object.assign(params, {
            'X-Context-Orn': contextOrn
        })

        return fetchContentIfNeeded(this)
    }
}


// WEBPACK FOOTER //
// src/actions/osprey-api/audiences/audience-estimated-consumers.js